// Defines the function to handle form submission
function handleStockFormSubmission(event) {
    event.preventDefault(); // Prevent the default form submission

    // Define elements
    const backInStockForm = document.getElementById('backInStockForm');
    const backInStockFormSuccessMessage = document.getElementById('backInStockFormSuccessMessage');
    const backInStockFormErrorMessage = document.getElementById('backInStockFormErrorMessage');

    // Extract values from the form
    const email = this.email.value;
    const shopifyCatalogVariantId = this.shopifyCatalogVariantId.value;
    const publicApiKey = this.publicApiKey.value;
  
    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${shopifyCatalogVariantId}`
            }
          }
        }
      }
    };
  
    const requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2023-12-15"
        },
        body: JSON.stringify(payload),
    };
  
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${publicApiKey}`, requestOptions)
        .then(response => {
            if (response.ok) {
            // If the response is a success (2XX status code)
            backInStockForm.style.display = 'none'; // Hide the form
            backInStockFormSuccessMessage.classList.remove("hidden"); // Show success message
            } else {
            // If the response is an error (4XX status code)
            backInStockForm.style.display = 'none'; // Hide the form
            backInStockFormErrorMessage.classList.remove("hidden"); // Show error message
            }
        })
        .catch(error => {
            console.log('error', error);
            backInStockForm.style.display = 'none'; // Hide the form on any network error
            backInStockFormErrorMessage.classList.remove("hidden"); // Show error message
        });
    
}

// Defines the function to attach the event listener
function attachStockFormSubmitListener() {
    const form = document.getElementById('backInStockForm');
    if (form) {
        form.addEventListener('submit', handleStockFormSubmission);
    }
}

// Attach the event listener
attachStockFormSubmitListener();